module.exports = __webpack_public_path__ + "img/appstore.4f3c235b.png";